import { MongoObservable } from 'meteor-rxjs';
import { Customer } from '../models/customer';

export const Customers = new MongoObservable.Collection<Customer>('customers');

if (Meteor.isServer) {
  Customers.rawCollection().createIndex({ 'msalConfig.emailDomains': 1 });
  Customers.rawCollection().createIndex({ 'adfsConfig.emailDomains': 1 });
  Customers.rawCollection().createIndex({ dispoIds: 1 });
  Customers.rawCollection().createIndex({ 'pool.activeUserIds': 1 });
  Customers.rawCollection().createIndex({ 'pool.requestedUserIds': 1 });
  Customers.rawCollection().createIndex({ 'pool.registeredUserIds': 1 });
  Customers.rawCollection().createIndex({ 'pool.formerUserIds': 1 });
  Customers.rawCollection().createIndex({
    'pool.jobsSharedWithCustomerIds': 1,
  });
  Customers.rawCollection().createIndex({
    'pool.employmentsSharedWithCustomerIds': 1,
  });
}
